export default {
    DEFAULT_SEARCH_FIELDS_HANDLE : '__default__',
    ACTIVE_PROJECTION_HANDLE : '__active_projection__',
    FUZZY_SEARCH : 'fuzzy',
    EXACT_SEARCH : 'exact',
};
